module.exports = __webpack_public_path__ + "assets/img/h3_cover.307ae99a.jpg";